import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    postRes: null,
    getRes: null,
    getByIdRes: null,
    putRes: null,
    deleteRes: null,
};

const slice = createSlice({
    name: 'labDepartment',
    initialState,
    reducers: {
        postLabDepartmentRequest: (state) => {
            state.loading = true;
        },
        postLabDepartmentSuccess: (state, action) => {
            state.loading = false;
            state.postRes = action.payload;
        },
        postLabDepartmentFailure: (state, action) => {
            state.loading = false;
            state.postRes = action.payload;
        },
        resetPostLabDepartment: (state) => {
            state.postRes = null;
        },

        getLabDepartmentRequest: (state) => {
            state.loading = true;
        },
        getLabDepartmentSuccess: (state, action) => {
            state.loading = false;
            state.getRes = action.payload;
        },
        getLabDepartmentFailure: (state, action) => {
            state.loading = false;
            state.getRes = action.payload;
        },
        resetGetLabDepartment: (state) => {
            state.getRes = null;
        },

        getLabDepartmentByIdRequest: (state) => {
            state.loading = true;
        },
        getLabDepartmentByIdSuccess: (state, action) => {
            state.loading = false;
            state.getByIdRes = action.payload;
        },
        getLabDepartmentByIdFailure: (state, action) => {
            state.loading = false;
            state.getByIdRes = action.payload;
        },
        resetGetLabDepartmentById: (state) => {
            state.getByIdRes = null;
        },

        putLabDepartmentRequest: (state) => {
            state.loading = true;
        },
        putLabDepartmentSuccess: (state, action) => {
            state.loading = false;
            state.putRes = action.payload;
        },
        putLabDepartmentFailure: (state, action) => {
            state.loading = false;
            state.putRes = action.payload;
        },
        resetPutLabDepartment: (state) => {
            state.putRes = null;
        },

        deleteLabDepartmentRequest: (state) => {
            state.loading = true;
        },
        deleteLabDepartmentSuccess: (state, action) => {
            state.loading = false;
            state.deleteRes = action.payload;
        },
        deleteLabDepartmentFailure: (state, action) => {
            state.loading = false;
            state.deleteRes = action.payload;
        },
        resetDeleteLabDepartment: (state) => {
            state.deleteRes = null;
        },
    }
});

export const {
    postLabDepartmentRequest, postLabDepartmentSuccess, postLabDepartmentFailure, resetPostLabDepartment,
    getLabDepartmentRequest, getLabDepartmentSuccess, getLabDepartmentFailure, resetGetLabDepartment,
    getLabDepartmentByIdRequest, getLabDepartmentByIdSuccess, getLabDepartmentByIdFailure, resetGetLabDepartmentById,
    putLabDepartmentRequest, putLabDepartmentSuccess, putLabDepartmentFailure, resetPutLabDepartment,
    deleteLabDepartmentRequest, deleteLabDepartmentSuccess, deleteLabDepartmentFailure, resetDeleteLabDepartment,
} = slice.actions;

export default slice.reducer;
